import React from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { CreateNewProject } from '../projects/CreateNewProject'
import { ProjectList } from '../projects/ProjectList'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}))

export function HomePage(): React.ReactElement {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Helmet title={t('home.title')} />

      <Box className={classes.buttons}>
        <CreateNewProject />
      </Box>

      <ProjectList />
    </Box>
  )
}
